import { render, staticRenderFns } from "./ProvisionedOrdersMeal.vue?vue&type=template&id=0d5c72d9"
import script from "./ProvisionedOrdersMeal.vue?vue&type=script&lang=js"
export * from "./ProvisionedOrdersMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports